import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b46ab94e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b46ab94e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46ab94e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b46ab94e')) {
      api.createRecord('b46ab94e', component.options)
    } else {
      api.reload('b46ab94e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b46ab94e&scoped=true", function () {
      api.rerender('b46ab94e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/purchase/index.vue"
export default component.exports